import { ContractTypeData } from '@sales/models/contract.model';
import { UpfrontPaymentMethod } from '../enums/payment-type';
import { CaptureRequest } from '@app/sales/models/order-capture.model';

export class OrderStateModel {
  orderCaptureId: number;
  orderServiceId: number;
  contractId: string;
  customerId: string;
  salesChannel: string = 'Diego';
  dealerId: string;
  upfrontPaymentMethod: UpfrontPaymentMethod;
  upfrontPaymentContactNumber: string;
  isExistingCustomer: boolean;
  salesPersonId: string;
  externalShoppingCartId: string;
  shipmentOption: ShipmentOption;
  isContractRequired: boolean;
  isLoadingOrder: boolean;
  placeOrderError: string;
  contractSigningMethod: ContractTypeData;
  isServiceOrder?: boolean;
  updatedProductIdentifierMsisdns: string[];
  bankIdMsisdn?: string;
  bankIdEmail?: string;
  bankIdBypassNote?: string;
  isBankIdBypassed: boolean;
}

export class BypassInfoRequest {
  bypassCategory: BypassCategory;
  notes: string;
  bypassedByUserId: string;
}

export class ShipmentOption {
  offeringId: string;
  deliveryOptionId: string;
  name: string;
}

export class CustomerDetails {
  existingCustomerId: string;
  email: string;
  phone: string;
  customerAllowance: CustomerAllowance;
  newCustomerAddress: CustomerAddress;
  newCustomerInvoiceType: string;
  newCustomerConsentChecked: boolean;
  hasSecretNumber: boolean;

  deliveryRecipientName: string;
  deliveryContactEmail: string;
  deliveryContactPhone: string;
  deliveryAddress: CustomerDeliveryAddress;
}

export class CustomerDeliveryAddress {
  streetAddress: string;
  streetAddress2: string;
  postalCode: string;
  city: string;
}

export class CustomerAllowance {
  SSN: string;
  firstName: string;
  lastName: string;
}

export class CustomerAddress {
  streetAddress: string;
  postalCode: string;
  city: string;
}

export class OrderItem {
  quantity: number;
  productOffering: ProductOffering;
  product: OrderItemProduct;
}

export class ProductOffering {
  id: string;
  name?: string;
  href?: string;
}

// Matches API-model "Product"
export class OrderItemProduct {
  name?: string;
  description?: string;
  isBundle: boolean;
  captureRequest: CaptureRequest;
}

export class ProductOrderRequest {
  description: string;
  category: OrderCategories;
  orderItems: OrderItem[] = [];
  relatedParties: RelatedParty[];
  notes: Note[];
  salesChannel: SalesChannel;
  upfrontPaymentMethod: UpfrontPaymentMethod;
  upfrontPaymentContactNumber: string;
  externalShoppingCartId: string;
  customerDetails: CustomerDetails;
  shipmentOption: ShipmentOption;
  contract?: ContractTypeData;
  bankIdVerificationId: string;
  bankIdMsisdn?: string;
  bankIdEmail?: string;
  bypassInfoRequest?: BypassInfoRequest;

  constructor() {
    this.salesChannel = new SalesChannel();
    this.customerDetails = new CustomerDetails();
    this.shipmentOption = new ShipmentOption();
  }
}

export class RelatedParty {
  id: string;
  name: string;
  href?: string;
}

export class Note {
  author: string;
  date: Date;
  text: string;
}

export class SalesChannel {
  id: string = 'Diego';
  name: string = 'Diego';
}

export enum OrderCategories {
  ServiceOrder = 'Service Order',
  B2CProductOrder = 'B2C Product Order',
}

export enum BypassCategory {
  BankId = 'BankId',
  Unknown = 'Unknown',
}
